<template>
    <div class="overlay">
        <div class="fsk_overlay">
            <div class="aspect"></div>
            <div class="overlay_content" :class="{'fsk16': showFsk16, 'fsk18': showFsk18, 'faded': faded, 'hidden': hidden}">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FSKOverlay",

    data () {
        return {
            showFsk16: false,
            showFsk18: false,
            hidden: false,
            faded: false,
            fadeTimer: null,

        }
    },

    events: {

        jwAdPlay () {
            clearTimeout(this.fadeTimer);
            this.hidden = true;
            this.faded = true;
        },

        jwPlay () {
            clearTimeout(this.fadeTimer);

            this.hidden = false;
            this.faded = false;

            var vm = this;
            this.fadeTimer = setTimeout(function(){
                vm.faded = true;
            }, 3000);
        },

        jwPause () {
            clearTimeout(this.fadeTimer);
            this.faded = false;
        },

        newItemData(evt) {
            this.$l.log('FSK: received newItemData event', this.$item)

            this.showFsk16 = false;
            this.showFsk18 = false;

            switch(this.$item.ageRating) {
                case 16:
                    this.showFsk16 = true;
                    this.showFsk18 = false;
                    this.$events.$emit('fskOverlayVisible',true);
                    break;

                case 18:
                    this.showFsk16 = false;
                    this.showFsk18 = true;
                    this.$events.$emit('fskOverlayVisible',true);
                    break;

                default:
                    this.showFsk16 = false;
                    this.showFsk18 = false;
                    this.$events.$emit('fskOverlayVisible',false);
                    break;
            }
        },
    },
}
</script>

<style scoped>
    .overlay {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;

        z-index: 9999;
        pointer-events: none;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .fsk_overlay {
        /*background: white;*/
        /*position: absolute;*/
        /*top:0;*/
        /*right:0;*/
        width: 100%;
        height: auto !important;
        position: relative;
        /*background: rgba(200,0,0,0.2);*/
    }

    .overlay_content {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        transition: opacity 2s;
    }

    .overlay_content.fsk16 {
        background: transparent url("../../assets/fsk16.png") no-repeat top right;
        background-size: contain;
    }

    .overlay_content.fsk18 {
        background: transparent url("../../assets/fsk18.png") no-repeat top right;
        background-size: contain;
    }

    .overlay_content.faded {
        opacity: 0;
    }

    .overlay_content.hidden {
        display: none;
    }

    .aspect {
        padding-top: 56.25%;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/overlays/FSKOverlay.vue